export class Group<K, T> {
    public readonly key: K;
    private readonly _items: T[];

    constructor(key: K, items: T[]) {
        this.key = key;
        this._items = items;
    }

    public push(item: T) {
        this._items.push(item);
    }

    get items(): T[] {
        return this._items;
    }
}
